import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=0cbc9ab3&scoped=true&"
import script from "./TestComponent.vue?vue&type=script&setup=true&lang=js&"
export * from "./TestComponent.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc9ab3",
  null
  
)

export default component.exports